<template>
  <div class="container-fluid">
    <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
    <div class="row">
      <div class="col-md-12">
        <h3>Manage Role: {{selectedRole.roleName}}</h3>

        <p>This section allows you to modify the permissions for the roles chosen above.
          Please click on the module name on the left section below to modify its permissions.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3"
           style="min-width: 360px;
                 border-right: solid 1px #e7e7e7;
                 overflow-y: auto;
                 overflow-x: hidden;
                 max-height: 67vh;
                 border-top: solid 1px #e7e7e7;"
      >
        <div style="border-bottom: solid 1px #e6e6e6; padding: 15px;">
          <strong>Module Groups</strong>
        </div>

        <div v-if="calculateModules(moduleGroup.id)" v-for="moduleGroup in moduleGroups">
          <div class="row prehighlight" style="border-bottom: solid 1px #e6e6e6;" @click="selectModuleGroup(moduleGroup.id)" :class="{highlighted: selectedModuleGroup.id == moduleGroup.id}">
            <div class="col">
              <h6><icon name="codepen"></icon> {{moduleGroup.name}}</h6>
            </div>
          </div>
          <div v-for="module in computedModules"  v-if="selectedModuleGroup.id == moduleGroup.id">
            <div class="row prehighlight2" style="border-bottom: solid 1px #e6e6e6;" :class="{highlighted2: selectedModule.moduleID == module.moduleID}">
              <div class="col" @click="selectModule(module.moduleID)">
                <div class="prehighlight2" >
                  &nbsp; &nbsp;  &nbsp;  <icon name="crosshairs"></icon> {{module.moduleName}}
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="col listxxx" style="overflow-y: auto; height: 67vh;  overflow-x: hidden;  border-top: solid 1px #e7e7e7;">
        <div style="border-bottom: solid 1px #e6e6e6; padding: 15px; width: 100%;">
          <strong>{{selectedModuleGroup.name}} > {{selectedModule.moduleName}}</strong>
        </div>

        <div class="row" style="border-bottom: solid 1px #f0f0f0; padding-left: 30px; padding-top: 15px;">
          <p>{{selectedModule.description}}</p>

          <transition name="slide" mode="out-in">
            <div class="table-responsive" :key="selectedModule.moduleID">
              <table class="table table-hover table-striped" v-if="computedScopes.length > 0">
                <thead>
                <tr>
                  <th scope="col">Permissions</th>
                  <th scope="col">Read</th>
                  <th scope="col">Create</th>
                  <th scope="col">Update</th>
                  <th scope="col">Delete</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="scope in computedScopes">
                  <td>{{scope.scopeName}}</td>
                  <td>
                    <toggle-button :value="checkPermission(selectedModule.moduleID, selectedRole.roleID, scope.scopeID, 1)"
                                   color="#82C7EB"
                                   @change="togglePermissions(selectedModule.moduleID, selectedRole.roleID, scope.scopeID, 1)"
                                   :sync="true"
                                   :labels="{checked: 'Yes', unchecked: 'No'}">
                    </toggle-button>
                  </td>
                  <td>
                    <toggle-button :value="checkPermission(selectedModule.moduleID, selectedRole.roleID, scope.scopeID, 2)"
                                   color="#82C7EB"
                                   @change="togglePermissions(selectedModule.moduleID, selectedRole.roleID, scope.scopeID, 2)"
                                   :sync="true"
                                   :labels="{checked: 'Yes', unchecked: 'No'}">
                    </toggle-button>
                  </td>
                  <td>
                    <toggle-button :value="checkPermission(selectedModule.moduleID, selectedRole.roleID, scope.scopeID, 3)"
                                   color="#82C7EB"
                                   @change="togglePermissions(selectedModule.moduleID, selectedRole.roleID, scope.scopeID, 3)"
                                   :sync="true"
                                   :labels="{checked: 'Yes', unchecked: 'No'}">
                    </toggle-button>
                  </td>
                  <td>
                    <toggle-button :value="checkPermission(selectedModule.moduleID, selectedRole.roleID, scope.scopeID, 4)"
                                   color="#82C7EB"
                                   @change="togglePermissions(selectedModule.moduleID, selectedRole.roleID, scope.scopeID, 4)"
                                   :sync="true"
                                   :labels="{checked: 'Yes', unchecked: 'No'}">
                    </toggle-button>
                  </td>
                </tr>
                <tr v-if="computedRelatedModules.length > 0">
                  <td colspan="5" style="background-color: white;"><strong @click="computedRelatedModules1()">Related Modules</strong></td>
                </tr>
                <tr v-for="relatedModule in computedRelatedModules">
                  <td>{{relatedModule.moduleName}}</td>
                  <td>
                    <toggle-button :value="checkRelatedPermission(relatedModule.relationshipID, 1)"
                                   color="#82C7EB"
                                   @change="toggleRelatedPermissions(relatedModule.relationshipID, 1)"
                                   :sync="true"
                                   :labels="{checked: 'Yes', unchecked: 'No'}">
                    </toggle-button>
                  </td>
                  <td>
                    <toggle-button :value="checkRelatedPermission(relatedModule.relationshipID, 2)"
                                   color="#82C7EB"
                                   @change="toggleRelatedPermissions(relatedModule.relationshipID, 2)"
                                   :sync="true"
                                   :labels="{checked: 'Yes', unchecked: 'No'}">
                    </toggle-button>
                  </td>
                  <td>
                    <toggle-button :value="checkRelatedPermission(relatedModule.relationshipID, 3)"
                                   color="#82C7EB"
                                   @change="toggleRelatedPermissions(relatedModule.relationshipID, 3)"
                                   :sync="true"
                                   :labels="{checked: 'Yes', unchecked: 'No'}">
                    </toggle-button>
                  </td>
                  <td>
                    <toggle-button :value="checkRelatedPermission(relatedModule.relationshipID, 4)"
                                   color="#82C7EB"
                                   @change="toggleRelatedPermissions(relatedModule.relationshipID, 4)"
                                   :sync="true"
                                   :labels="{checked: 'Yes', unchecked: 'No'}">
                    </toggle-button>
                  </td>
                </tr>

                <tr v-if="modulesWithFilter.includes(selectedModule.moduleName)">
                  <td colspan="5" style="background-color: white;"><strong>Custom Filter</strong></td>
                </tr>
                <tr v-if="!newFilter && modulesWithFilter.includes(selectedModule.moduleName)">
                  <td>{{selectedSearchFilter.name}}</td>
                  <td>
                    <toggle-button :value="checkRelatedPermissionFilter(selectedSearchFilter.actions, 1)"
                                   color="#82C7EB"
                                   @change="toggleRelatedPermissionsFilter(selectedSearchFilter.actions, 1)"
                                   :sync="true"
                                   :labels="{checked: 'Yes', unchecked: 'No'}">
                    </toggle-button>
                  </td>
                  <td>
                    <toggle-button :value="checkRelatedPermissionFilter(selectedSearchFilter.actions, 2)"
                                   color="#82C7EB"
                                   @change="toggleRelatedPermissionsFilter(selectedSearchFilter.actions, 2)"
                                   :sync="true"
                                   :labels="{checked: 'Yes', unchecked: 'No'}">
                    </toggle-button>
                  </td>
                  <td>
                    <toggle-button :value="checkRelatedPermissionFilter(selectedSearchFilter.actions, 3)"
                                   color="#82C7EB"
                                   @change="toggleRelatedPermissionsFilter(selectedSearchFilter.actions, 3)"
                                   :sync="true"
                                   :labels="{checked: 'Yes', unchecked: 'No'}">
                    </toggle-button>
                  </td>
                  <td>
                    <toggle-button :value="checkRelatedPermissionFilter(selectedSearchFilter.actions, 4)"
                                   color="#82C7EB"
                                   @change="toggleRelatedPermissionsFilter(selectedSearchFilter.actions, 4)"
                                   :sync="true"
                                   :labels="{checked: 'Yes', unchecked: 'No'}">
                    </toggle-button>
                  </td>
                </tr>


                <tr v-if="!newFilter && employeeFilter.includes(selectedModule.moduleName)"><td colspan="5"><strong>Cost Companies</strong></td></tr>
                <tr v-if="!newFilter && employeeFilter.includes(selectedModule.moduleName)"><td colspan="5">
                  <div class="row">
                    <div class="col-md-3">
                      <multiselect
                          v-model="updateSearchFilter.companies2"
                          @input="onSelectCostCompany3"
                          :options="companies"
                          placeholder="Select Company"
                          label="name" track-by="id">
                      </multiselect>
                    </div>
                    <div class="col" style="margin-top: 5px;">
                      <span v-for="company in updateSearchFilter.companies" style="min-width: 200px; margin-right: 10px; padding: 10px 5px 10px 10px; background-color: white; border: solid 1px #bababa;">
                        <strong>{{findCompany(company).name}} &nbsp;</strong>
                        <button @click="deleteCostCompany(company)" style="cursor: pointer;"  class="btn-small btn-danger float-right;"><icon name="times" scale="1"></icon></button>
                      </span>
                    </div>
                  </div>
                </td></tr>

                <tr v-if="!newFilter && employeeFilter.includes(selectedModule.moduleName)"><td colspan="5"><strong>Sponsor Companies</strong></td></tr>
                <tr v-if="!newFilter && employeeFilter.includes(selectedModule.moduleName)"><td colspan="5">
                  <div class="row">
                    <div class="col-md-3">
                      <multiselect
                          v-model="updateSearchFilter.sponsorCompanies2"
                          @input="onSelectSponsorCompany3"
                          :options="companies"
                          placeholder="Select Company"
                          label="name" track-by="id">
                      </multiselect>
                    </div>
                    <div class="col" style="margin-top: 5px;">
                      <span v-for="company in updateSearchFilter.sponsorCompanies" style="min-width: 200px; margin-right: 10px; padding: 10px 5px 10px 10px; background-color: white; border: solid 1px #bababa;">
                        <strong>{{findCompany(company).name}} &nbsp;</strong>
                        <button @click="deleteSponsorCompany(company)" style="cursor: pointer;"  class="btn-small btn-danger float-right;"><icon name="times" scale="1"></icon></button>
                      </span>
                    </div>
                  </div>
                </td></tr>


                <tr v-if="!newFilter && employeeFilter.includes(selectedModule.moduleName)"><td colspan="5"><strong>Branches</strong></td></tr>
                <tr v-if="!newFilter && employeeFilter.includes(selectedModule.moduleName)"><td colspan="5">
                  <div class="row">
                    <div class="col-md-3">
                      <multiselect
                          v-model="updateSearchFilter.branches2"
                          @input="onSelectBranch"
                          :options="branches"
                          placeholder="Select Branch"
                          label="name" track-by="id">
                      </multiselect>
                    </div>
                    <div class="col" style="margin-top: 5px;">
                      <span v-for="branch in updateSearchFilter.branches" style="min-width: 200px; margin-right: 10px; padding: 10px 5px 10px 10px; background-color: white; border: solid 1px #bababa;">
                        <strong>{{findBranch(branch).name}} &nbsp;</strong>
                        <button @click="deleteBranch(branch)" style="cursor: pointer;"  class="btn-small btn-danger float-right;"><icon name="times" scale="1"></icon></button>
                      </span>
                    </div>
                  </div>
                </td></tr>

                <tr v-if="!newFilter && employeeFilter.includes(selectedModule.moduleName)"><td colspan="5"><strong>Departments</strong></td></tr>
                <tr v-if="!newFilter && employeeFilter.includes(selectedModule.moduleName)"><td colspan="5">
                  <div class="row">
                    <div class="col-md-3">
                      <multiselect
                          v-model="updateSearchFilter.departments2"
                          @input="onSelectDepartment3"
                          :options="departments"
                          placeholder="Select Department"
                          label="name" track-by="id">
                      </multiselect>
                    </div>
                    <div class="col" style="margin-top: 5px;">
                      <span v-for="department in updateSearchFilter.departments" style="min-width: 200px; margin-right: 10px; padding: 10px 5px 10px 10px; background-color: white; border: solid 1px #bababa;">
                        <strong>{{findDepartment(department).name}} &nbsp;</strong>
                        <button @click="deleteDepartment(department)" style="cursor: pointer;"  class="btn-small btn-danger float-right;"><icon name="times" scale="1"></icon></button>
                      </span>
                    </div>
                  </div>
                </td></tr>

                <tr v-if="!newFilter && shiftFilter.includes(selectedModule.moduleName)"><td colspan="5"><strong>Select Shift Category:</strong></td></tr>
                <tr v-if="!newFilter && shiftFilter.includes(selectedModule.moduleName)"><td colspan="5">
                  <div class="row">
                    <div class="col-md-3">
                      <multiselect
                          v-model="updateSearchFilter.shiftCategories2"
                          @input="onSelectShiftCategories"
                          :options="shiftCategories"
                          placeholder="Select Shift Categories"
                          label="name" track-by="id">
                      </multiselect>
                    </div>
                    <div class="col" style="margin-top: 5px;">
                      <span v-if="findShiftCategories(shiftCategory)" v-for="shiftCategory in updateSearchFilter.shiftCategories" style="min-width: 200px; margin-right: 10px; padding: 10px 5px 10px 10px; background-color: white; border: solid 1px #bababa;">
                        <strong>{{findShiftCategories(shiftCategory).name}} &nbsp; </strong>
                        <button @click="deleteShiftCategories(shiftCategory)" style="cursor: pointer;"  class="btn-small btn-danger float-right;"><icon name="times" scale="1"></icon></button>
                      </span>
                    </div>
                  </div>
                </td></tr>

                <tr v-if="!newFilter && modulesWithFilter.includes(selectedModule.moduleName)"><td colspan="5"><button @click="updateSearchFilters" class="btn btn-primary float-right"><icon name="refresh"></icon> Update Filter</button></td></tr>


                <tr v-if="newFilter && modulesWithFilter.includes(selectedModule.moduleName)">
                  <td colspan="5">
                    <div class="row">
                      <div class="col-md-3">
                        <strong>Please enter the filter name:</strong>
                      </div>
                      <div class="col" style="margin-top: 5px;">
                        <input type="text" v-model="createSearchFilter.name">
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-if="newFilter && modulesWithFilter.includes(selectedModule.moduleName)"><td colspan="5"><button @click="createSearchFilters" class="btn btn-primary float-right"><icon name="refresh"></icon> Store Filter</button></td></tr>



                </tbody>
              </table>
            </div>
          </transition>

        </div>

      </div>
    </div>

  </div>
</template>

<script>

    // TODO: Sort out warnings in the console

    import {Form, Errors} from '@/components/validations/forms';

    import {mixin} from '@/mixins/mixins';
    export default {
        mixins: [mixin],
        data () {
            return {
                breadcrumbs: [
                    {text: 'Home', to: '/dashboard'},
                    {text: 'Settings', to: '/settings'},
                    {text: 'Security Roles', to: '/settings/roles'},
                    {text: 'Manage Role', active: true},
                ],
                roles: [],
                selectedRole: {},
                permissions: [],
                relatedPermissions: [],
                selectedPermission: null,
                moduleGroups: [],
                selectedModuleGroup: null,
                modules: [],
                selectedModule: null,
                relatedModules: [],
                selectedRelatedModule: null,
                actions: [],
                selectedAction: null,
                scopes: [],
                selectedScope: null,
                selectedSearchFilter: {},
                companies: this.$store.getters['environment/getCompanies'],
                branches: this.$store.getters['environment/getBranches'],
                departments: this.$store.getters['environment/getDepartments'],
                newFilter: true,
                modulesWithFilter: ['Employees', 'Shifts'],
                employeeFilter: ['Employees'],
                shiftFilter: ['Shifts'],
                shiftCategories: this.$store.getters['shifts/getShiftCategories'],

                createSearchFilter: new Form({
                    name: null,
                    roleID: null,
                    moduleID: null,
                    actions: [],
                    companies: [],
                    sponsorCompanies: [],
                    branches: [],
                    departments: [],
                    companies2: [],
                    sponsorCompanies2: [],
                    branches2: [],
                    departments2: [],
                    shiftCategories: [],
                    shiftCategories2: [],
                }),

                updateSearchFilter: new Form({
                    id: null,
                    name: null,
                    roleID: null,
                    moduleID: null,
                    actions: [],
                    companies: [],
                    sponsorCompanies: [],
                    branches: [],
                    departments: [],
                    companies2: [],
                    sponsorCompanies2: [],
                    branches2: [],
                    departments2: [],
                    shiftCategories: [],
                    shiftCategories2: [],
                }),

            }
        },

        methods: {

            selectRole() {
                let route = this.$route.params.roleID;
                let needle = this.roles.filter(function (el) {return el.roleID == parseInt(route);})
                if(needle.length > 0){this.selectedRole = needle[0];}
                else {alert('Invalid Role Parameters'); this.$router.push('/settings/roles');}
                this.$store.dispatch('security/fetchRelatedPermissions', {roleID: this.selectedRole.roleID,})
                    .then(()=>{this.relatedPermissions = this.$store.getters['security/getRelatedPermissions'];
                    })
            },

            selectModuleGroup(moduleGroupID)
            {
                let moduleGroups = this.moduleGroups
                let needle = moduleGroups.filter(function (el) {return el.id == parseInt(moduleGroupID);})
                if(needle.length > 0){this.selectedModuleGroup = needle[0];}
            },

            selectModule(moduleID)
            {
                let modules = this.modules
                let needle = modules.filter(function (el) {return el.moduleID == parseInt(moduleID);})
                if(needle.length > 0){this.selectedModule = needle[0];}
                this.delaySelectSearchFilter();
                this.$store.dispatch('security/fetchRelatedPermissions', {roleID: this.selectedRole.roleID,})
                    .then(()=>{
                        this.relatedPermissions = this.$store.getters['security/getRelatedPermissions'];
                    })
            },

            delaySelectSearchFilter(){
                setTimeout(() => this.selectSearchFilter(), 2500);
            },

            selectSearchFilter()
            {
                if(this.selectedModule && this.selectedRole){
                    this.$store.dispatch('security/fetchSearchFilter', {
                        moduleID: this.selectedModule.moduleID,
                        roleID: this.selectedRole.roleID,
                    })
                        .then(response => {
                            if(response){
                                this.selectedSearchFilter = response;
                                this.updateSearchFilter.id = response.id;
                                this.updateSearchFilter.name = response.name;
                                this.updateSearchFilter.roleID = response.roleID;
                                this.updateSearchFilter.moduleID = response.moduleID;
                                this.updateSearchFilter.companies = JSON.parse(response.companies);
                                this.updateSearchFilter.sponsorCompanies = JSON.parse(response.sponsorCompanies);
                                this.updateSearchFilter.branches = JSON.parse(response.branches);
                                this.updateSearchFilter.departments = JSON.parse(response.departments);
                                this.updateSearchFilter.actions = JSON.parse(response.actions);
                                this.updateSearchFilter.shiftCategories = JSON.parse(response.shiftCategories);

                                this.newFilter = false;
                            } else{
                                this.newFilter = true;
                                this.createSearchFilter.name = null;
                                this.createSearchFilter.roleID = this.selectedRole.roleID;
                                this.createSearchFilter.moduleID = this.selectedModule.moduleID;
                            }

                        })
                }
            },
            onSelectCostCompany3(value){
                if(!this.updateSearchFilter.companies.includes(value.id)){
                    this.updateSearchFilter.companies.push(value.id);
                }
            },
            deleteCostCompany(compID){
                this.updateSearchFilter.companies = this.updateSearchFilter.companies.filter(e => e !== compID)
            },
            onSelectSponsorCompany3(value){
                if(!this.updateSearchFilter.sponsorCompanies.includes(value.id)){
                    this.updateSearchFilter.sponsorCompanies.push(value.id);
                }
            },
            deleteSponsorCompany(compID){
                this.updateSearchFilter.sponsorCompanies = this.updateSearchFilter.sponsorCompanies.filter(e => e !== compID)
            },
            onSelectDepartment3(value){
                if(!this.updateSearchFilter.departments.includes(value.id)){
                    this.updateSearchFilter.departments.push(value.id);
                }
            },
            deleteDepartment(compID){
                this.updateSearchFilter.departments = this.updateSearchFilter.departments.filter(e => e !== compID)
            },
            onSelectBranch(value){
                if(!this.updateSearchFilter.branches.includes(value.id)){
                    this.updateSearchFilter.branches.push(value.id);
                }
            },
            deleteBranch(compID){
                this.updateSearchFilter.branches = this.updateSearchFilter.branches.filter(e => e !== compID)
            },
            onSelectShiftCategories(value){
                if(!this.updateSearchFilter.shiftCategories.includes(value.id)){
                    this.updateSearchFilter.shiftCategories.push(value.id);
                }
            },
            deleteShiftCategories(compID){
                this.updateSearchFilter.shiftCategories = this.updateSearchFilter.shiftCategories.filter(e => e !== compID)
            },
            updateSearchFilters(){
                this.$store.dispatch('security/updateSearchFilter', this.updateSearchFilter)
                    .then(response => {
                        this.$snotify.success('Filters Updated Successfully', '');
                    })
                    .catch(error => {
                        this.timesheetsListLoading = false;
                    })
            },

            createSearchFilters(){
                this.$store.dispatch('security/storeSearchFilter', this.createSearchFilter)
                    .then(response => {
                        this.selectModule(this.selectedModule.moduleID)
                        this.$snotify.success('Filters Stored Successfully', '');
                    })
                    .catch(error => {
                        this.timesheetsListLoading = false;
                    })
            },




            calculateModules(groupID)
            {
                let modules = this.modules
                let needle = modules.filter(function (el) {
                    return el.module_groups_id == parseInt(groupID)
                        ;})
                if(needle.length > 0){return true;} else {return false;}
            },

            checkPermission(moduleID, roleID, scopeID, actionID) {
                let needle = this.permissions.filter(function (el) {
                    return el.actionID == parseInt(actionID) &&
                        el.roleID == parseInt(roleID) &&
                        el.scopeID == parseInt(scopeID) &&
                        el.moduleID == parseInt(moduleID)
                        ;})
                if(needle.length > 0){return true} else {return false}
            },

            togglePermissions(moduleID, roleID, scopeID, actionID)
            {
                this.$store.dispatch('security/assignPermissions', {
                    moduleID: moduleID,
                    roleID: roleID,
                    scopeID: scopeID,
                    actionID: actionID
                })
                    .then(response => {
                        this.$store.dispatch('security/fetchPermissions').then(response => {
                            this.permissions = this.$store.getters['security/getPermissions']
                        })
                    })
            },

            checkRelatedPermission(relationshipID, supposedAction){
                let relatedPermissions = this.relatedPermissions;
                let needle = relatedPermissions.filter(function (el) {
                    return el.relationshipID == parseInt(relationshipID) &&
                        el.actionID == parseInt(supposedAction);})
                if(needle.length > 0){return true;} else{return false;}
            },

            toggleRelatedPermissions(relationshipID, actions){
                this.$store.dispatch('security/saveRelatedPermissions', {
                    relationshipID: relationshipID,
                    actionID: actions,
                    roleID: this.selectedRole.roleID
                }).then(()=>{
                    this.$store.dispatch('security/fetchRelatedPermissions')
                        .then(()=>{this.relatedPermissions = this.$store.getters['security/getRelatedPermissions']})
                })
            },

            checkRelatedPermissionFilter(actions, supposedAction){
                return actions.includes(supposedAction);
            },
            toggleRelatedPermissionsFilter(actions, supposedAction){
                if(this.updateSearchFilter.actions.includes(supposedAction)){
                    this.updateSearchFilter.actions = this.updateSearchFilter.actions.filter(e => e !== supposedAction)
                } else{
                    this.updateSearchFilter.actions.push(supposedAction);
                }
            },
        },

        //.bind(this)

        computed: {
            computedModules(){
                let needle = null;
                let selectedModuleGroup = this.selectedModuleGroup.id
                let modules = this.modules
                needle = modules.filter(function (el) {
                    return el.module_groups_id == parseInt(selectedModuleGroup)
                        ;})
                if(needle.length > 0){return needle;} else {return false;}
            },

            computedScopes() {
                let selectedModule = this.selectedModule.moduleID
                let scopes = this.scopes
                let needle = scopes.filter(function (el) {
                    return el.moduleID == parseInt(selectedModule)
                        ;})
                if(needle.length > 0){return needle;} else {return false;}
            },

            computedRelatedModules() {
                let selectedModule = this.selectedModule.moduleID
                let relatedModules = this.relatedModules
                let needle = relatedModules.filter(function (el) {
                    return el.parentModule == parseInt(selectedModule)
                        ;})
                if(needle.length > 0){
                    let modulesList = []
                    let modules = this.modules
                    for (let i = 0; i < needle.length; i++) {
                        let needle2 = modules.filter(function (el) {return el.moduleID == parseInt(needle[i].childModule);})
                        if(needle2.length > 0){
                            needle2[0].relationshipID = needle[i].relationshipID;
                            needle2[0].actions = needle[i].actions;
                            modulesList.push(needle2[0])
                        }
                    }
                    return modulesList;
                }
                else {return false;}
            },

        },

        created () {
            this.$store.dispatch('security/fetchModuleGroups').then(response => {
                this.moduleGroups = this.$store.getters['security/getModuleGroups'];
                this.selectedModuleGroup = this.moduleGroups[0];
            })

            this.$store.dispatch('security/fetchModules').then(response => {
                this.modules = this.$store.getters['security/getModules'];
                this.selectedModule = this.modules[0];
                this.delaySelectSearchFilter();
            })

            this.$store.dispatch('security/fetchRelatedModules').then(response => {this.relatedModules = this.$store.getters['security/getRelatedModules']})
            this.$store.dispatch('security/fetchRoles').then(response => {this.roles = this.$store.getters['security/getRoles']; this.selectRole();})
            this.$store.dispatch('security/fetchPermissions').then(response => {this.permissions = this.$store.getters['security/getPermissions']})
            this.$store.dispatch('security/fetchActions').then(response => {this.actions = this.$store.getters['security/getActions']})
            this.$store.dispatch('security/fetchScopes').then(response => {this.scopes = this.$store.getters['security/getScopes']})
            this.delaySelectSearchFilter();
        }

    }
</script>

<style>
  .highlighted{
    background-color: #EDEDED;
  }
  .prehighlight{
    cursor: pointer;
    padding-bottom: 10px;
    padding-top: 20px;
  }
  .prehighlight:hover{
    background-color: #EDEDED;
  }
  .prehighlight2{
    cursor: pointer;
    padding-bottom: 5px;
    padding-top: 5px;
  }
  .prehighlight2:hover{
    background-color: #EDEDED;
  }
  .highlighted2{
    background-color: #f6f6f6;
  }
</style>


// WEBPACK FOOTER //
// src/components/settings/users/permissions.vue